import React, { Component } from 'react';
import { inject } from 'mobx-react';

export default WrappedComponent => {
  const HOC = class RouteWatcherHOC extends Component {
    componentDidMount () {
      const page = this.props.location.pathname;
      this.props.uiStore.handleRouteChange(page);
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        this.props.uiStore.handleRouteChange(nextPage);
      }
    }

    render () {
      return <WrappedComponent {...this.props} />;
    }
  };

  return inject('uiStore')(HOC);
};
